import * as firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';
import 'firebase/messaging';

const defaultFbConfig = { apiKey: 'mock-api-key', projectId: 'mock-project' };
const parsedJson = process.env.REACT_APP_FB_JSON ? JSON.parse(process.env.REACT_APP_FB_JSON) : defaultFbConfig;

const fbApp = firebase.initializeApp(parsedJson)

export default fbApp;